import { render, staticRenderFns } from "./IceLegend.vue?vue&type=template&id=7fc6ff27&"
import script from "./IceLegend.vue?vue&type=script&lang=js&"
export * from "./IceLegend.vue?vue&type=script&lang=js&"
import style0 from "./IceLegend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports